import { useUserStore } from '/@/kernel-mn/stores/user';
import { storeToRefs } from 'pinia';
import { ref } from "vue";
import { useHot } from "/@/kernel-mn/stores/useHot.ts";
import { showConfirmDialog } from "vant";
import { mb_err, mb_loading, mb_t, mb_toast } from "/@/plugins/global.ts";
import { FBQRecordEvent } from "/@/plugins/appsFlyer.ts";
import { remove } from "/@/kernel-mn/utils/storage.ts";
import { removeLastNotice } from "/@/hooks/message.ts";

// 获取用户认证信息
export const getCertificationInfo = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqCertificationInfo(payload);
}

// 检查认证状态
export const isCert = async () => {
  // 0都没认证，2已认证，3待审核，4审核拒绝需要重新认证
  // withdraw_attestation: '0', // 是否开启认证 0否 1是
  // @ts-ignore
  const userStore = useUserStore();
  let res: any = await getCertificationInfo();
  let cer = res.rz2_state;
  // @ts-ignore
  let isopen = userStore.certification.withdraw_attestation;
  if (cer !== undefined) {
    return +isopen === 0 ? 2 : cer; // 没有开启 直接过
  } else {
    return +res.withdraw_attestation === 0 ? 2 : res.rz2_state; // 没有开启 直接过
  }
};

// 提交认证信息
export const reqIDCertification = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqIDCertification(payload);
}
// 提交邮箱认证
export const reqEmailCertification = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqEmailCertification(payload);
}
// 发送邮箱验证码
export const reqEmailCode = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqEmailCode(payload);
}

// 获取用户银行卡列表
export const getBindBankList = (payload = []) => {
  const userStore = useUserStore();
  return userStore.reqBindBankList(payload);
}

// 检查提现密码
export const testWithdrawPassword = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqTestWithdrawPassword(payload);
}

// 添加绑定银行卡 虚拟币等
export const reqBindCard = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqBindCard(payload);
}

// 获取银行列表 currency:国家 如CNY
export const getBankList = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqBankList(payload);
}

// 获取用户绑定的银行卡列表
export const getUserBinkList = () => {
  const userStore = useUserStore();
  userStore.reqBindBankList();
  const { bindBanklist } = storeToRefs(userStore);
  return bindBanklist;
};
// 获取用户默认绑卡列表 及 是否有权限绑类型的卡
export const getDefaultBankCard2 = () => {
  const userStore = useUserStore();
  userStore.reqDefaultBankCard2();
  // const { defaultCard } = storeToRefs(userStore);
  // return defaultCard;
};
// 设置默认卡
export const setDefaultBankCard = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqReDefaultBankCard(payload);
};

// 提现页面数据获取
export const reqWithdrawLimint = (payload = []) => {
  const userStore = useUserStore();
  return userStore.reqWithdrawLimint(payload);
}

// 发起提现
export const sendAddWithdraw = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAddWithdraw(payload);
}

// 获取线下充币大类列表 reset为真 则重新请求列表 同时查询线上线下
export const getOffinePayList = (reset = true, payload = {/*mark: 1 */ }, loading = ref(false)) => {
  const userStore = useUserStore();
  if (reset) {
    loading.value = true;
    userStore.reqPayList(payload).finally(() => {
      loading.value = false;
    });
  };
  const { XNBOffine, XNBOnLine, quickList } = storeToRefs(userStore);
  return { offinePay: XNBOffine, onLinePay: XNBOnLine, quickPay: quickList, loading };
};

// 获取线上充币大类列表 reset为真 则重新请求列表
export const getOnLinePayList = (
  reset = true,
  payload = {
    /*mark: 2 */
  }
) => {
  const userStore = useUserStore();
  reset && userStore.reqPayList(payload);
  const { XNBOnLine } = storeToRefs(userStore);
  return XNBOnLine;
};

// 充值页面配置
export const getOffieConfig = (opt = 'OFFLINE_RECHARGE_LIMIT') => {
  const userStore = useUserStore();
  return userStore.reqOffineConfig(opt);
}
// 获取银行绑卡的一些配置 并且判断资金密码是否显示 fn为成功回调函数 errfn为失败回调函数额
export const getBindBankConfig = (option_code = 'BIND_CARD_FIELD', fn = null, errfn = null) => {
  // @ts-ignore
  let BIND_CARD_FIELD = window.BIND_CARD_FIELD;
  if (BIND_CARD_FIELD) {
    fn && fn(BIND_CARD_FIELD)
    return false;
  }
  let loading: any = null;
  loading && loading?.close();
  loading = mb_loading({ forbidClick: true });
  getOffieConfig(option_code).then((res: any) => {
    let isVisible = JSON.parse(res.value) || {};
    let isRequire = JSON.parse(res.value2) || {};
    let m_visble = isVisible.Comprehensive.M; // 手机端显示选项 2否 1是
    let m_require = isRequire.Comprehensive.M; // 手机端必填
    let result = { isVisible: m_visble, isRequire: m_require };
    // @ts-ignore
    window.BIND_CARD_FIELD = result; // 保存数据
    fn && fn(result);
  }).catch(err => {
    errfn && errfn(err);
  }).finally(() => {
    loading.close();
    loading = null;
  });
}

// 线下充值接口
export const sendAddPayOffine = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAddPayOffline(payload);
}
// 线上充值接口
export const sendAddPayOnline = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAddPayOnline(payload);
}

// 获取在线客服列表
export const getServiceList = (payload = { chan_con: 8, message_id: 50, apply: 6 }) => {
  const userStore = useUserStore();
  return userStore.reqServiceLists(payload);
}

// 获取客服token
export const customerGetTokenById = (payload = { origin: 'wangzhuan' }) => {
  const userStore = useUserStore();
  const { customerGetUrlQuery } = storeToRefs(userStore);
  if (customerGetUrlQuery.value) {
    return customerGetUrlQuery;
  }
  userStore.customerGetTokenById(payload);
  return customerGetUrlQuery;
}

// 在线客服url
export const getSeverUrl = () => {
  const { hotData: { tenantInfo, userInfo, isLogined } } = useHot();
  // 用户有登录 代理返点有配置客服链接 则用这个
  if (isLogined.value && userInfo.value.partner && userInfo.value.partner.kf_url) {
    // 是链接就直接跳转
    return userInfo.value.partner.kf_url;
  } else {
    let guestLink = tenantInfo.value.tenant.online_addr || '';
    if (tenantInfo.value.tenant && tenantInfo.value.tenant.online_addr) {
      // 内部打开 需要的地址中带有token
      if (tenantInfo.value.tenant.type === 0 && isLogined.value) {
        const token = customerGetTokenById();
        let urlToken = `?origin=wangzhuan&cust_id=${userInfo.value.cust_id}&token=${token}`;
        guestLink = guestLink + urlToken;
      } else if (tenantInfo.value.tenant.type === 1) {
        guestLink = tenantInfo.value.tenant.online_addr;
      }
    }
    return guestLink;
  }
}

// 退出登录
export const logout = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.logout(payload);
}

// 退出登录弹窗
export const logoutDialog = () => {
  return showConfirmDialog({
    title: mb_t('提示'),
    message: mb_t('确定要退出登录吗？'),
    cancelButtonText: mb_t('取消'),
    confirmButtonText: mb_t('确认'),
    beforeClose: action => {
      return new Promise(resolve => {
        if (action === 'confirm') {
          let payload = { app_key: '' };
          logout(payload).then((res: any) => {
            if (res && res.response_code === '9999') {
              FBQRecordEvent('logout');
              mb_toast(mb_t('退出成功'), 2);
              remove('userInfo');
              remove('game3LoginInfo');
              removeLastNotice(); // 清空公告id
              resolve(true);
            }
          }).catch(err => {
            mb_err(err.info, 2);
            resolve(false);
          });
        } else {
          // 拦截取消操作
          resolve(true);
        }
      });
    }
  });
};


// 修改登录密码
export const resetPassword = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.resetPassword(payload);
}

// 忘记密码
export const forgetPassword = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.forgetPassword(payload);
}

// 是否修改过密码
export const ifRePassword = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.ifRePassword(payload);
}

// 修改提现密码
export const resetWithdrawPassword = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.resetWithdrawPassword(payload);
}
// 重置提现密码
export const updatWithdrawPwd = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.updatWithdrawPwd(payload);
}

// 获取用户联系方式
export const getContact = () => {
  const userStore = useUserStore();
  return userStore.fetchContact();
}

// 修改联系方式
export const setContact = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reContact(payload);
}

// 修改昵称
export const reNickName = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reNickName(payload);
}

// VIP等级列表,并携带领取状态
export const getVipListWithStatus = () => {
  const userStore = useUserStore();
  return userStore.reqVipListWithStatus();
}
// VIP等级列表
export const getVipList = () => {
  const userStore = useUserStore();
  return userStore.reqVipList();
}
// 获取VIP详情
export const reqVipDetail = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.getVipDetail(payload);
}
// vip等级页面领取奖励和俸禄
export const rewardHandler = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.getRewardMoney(payload);
}
// 邀请好友-分享页面
export const getMyShare = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqMyShare(payload);
}
// 代理系统 - 邀请好友-分享页面
export const getAgentMyShare = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentMyShare(payload);
}
// 通过cust_id获取用户数据
export const getUserInfoByCustId = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.getUserInfoByCustId(payload);
}
// 更新用户信息
export const updateUserInfo = (data = {}) => {
  const userStore = useUserStore();
  userStore.saveUser(data);
}
// 余额宝 利息相关
export const getInterestData = () => {
  const userStore = useUserStore();
  return userStore.reqInterestData();
};
// 余额宝里面的钱 + 用户余额
export const getYuEbaoMoney = () => {
  const userStore = useUserStore();
  return userStore.getSafeRelated();
};
// 余额宝转入
export const reqYuEbaoIn = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.safeTransferInfo(payload);
};
// 余额宝转出
export const reqYuEbaoOut = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.safeTransferOut(payload);
};
// 验证余额宝 res.response_code === '9999' 表示成功
export const checkYuEbao = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.checkInterest(payload);
};
// 会员返水-MN项目 type // 0 今日，1 昨日，2 近7日，3 近15日，4 近30日
export const getReturnWashLists = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqReturnWashLists(payload);
};
// 检查活动状态 { activity_name: 'qiandao'|'hongbaoyu' } 签到 红包等
export const checkActivityState = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.checkActivity(payload);
};
// 红包 - 获取一个红包 packet_type 0,2普通红包 1拼手气 title:红包主题 money:金额
export const getHBOne = () => {
  const userStore = useUserStore();
  return userStore.reqHB();
};
// 红包 - 获取一个红包
export const getHBLists = () => {
  const userStore = useUserStore();
  return userStore.reqHBList();
};
// 红包 - 打开一个红包 {id:红包id}
export const openHBOne = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqOpenHB(payload);
};
// 红包 - 获取红包规则
export const getHBRules = () => {
  const userStore = useUserStore();
  return userStore.reqHBRules();
};
// 红包 - 获取红包中奖列表 cust_name:会员账号 red_name:红包主题 payout_amount:金额/1000 create_time:时间
export const getHBWinnerList = () => {
  const userStore = useUserStore();
  return userStore.reqHBWinnerList();
};
// 代理中心数据组
// 推广中心 - 代理制度
export const getDaiLiZhiDu = () => {
  const userStore = useUserStore();
  return userStore.reqAgentZhiDu();
};
// 推广中心 - 推广中心数据
export const getDaiLiCenter = () => {
  const userStore = useUserStore();
  return userStore.reqAgentCenter();
};
// 优惠活动列表查询 apply: 1 棋牌；2 网赚；3 综合彩票；3 老版彩票；
export const getActivityList = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqActivityListLeft(payload);
};
// 优惠活动详情 apply: 1 棋牌；2 网赚；3 综合彩票；3 老版彩票；
export const getActivityDetail = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqActivityDetail(payload);
};
// 代理 - 当前代理业绩
export const getAgentYeji = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentYeji(payload);
};
// 代理 - 当前代理业绩
export const getAgentChildYeji = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentChildYeji(payload);
};
// 代理 - 当前代理所有下级会员业绩 child_id:下级会员id start_time end_time page_start num_per_page 分页
export const getAgentChildUsers = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentChildUsers(payload);
};
// 代理 会员页面 - 下级会员游戏记录 start_time end_time type_id platform game_id cust_id为自定义用户id
export const getAgentChildGameRecord = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentChildGameRecord(payload);
};
// 代理 财务页面 - 优惠红利记录 startTime endTime partner_id:代理id receiveType:优惠类型
export const getAgentYouhuiRecord = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentYouhuiRecord(payload);
};
// 代理 财务页面 - 代存记录 start_time end_time child_id:查找的id
export const getAgentDaicunRecord = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentDaicunRecord(payload);
};
// 代理 财务页面 - 佣金记录  datetime:月份时间戳[2024-08]
export const getAgentFeeRecord = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentFeeRecord(payload);
};
// 代理 财务页面 - 平台费用 start_time end_time play_ids:游戏ID[1309,1401]
export const getAgentPingtaiFree = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentPingtaiFree(payload);
};
// 代理 财务页面 - 会员报表 start_time end_time day_type:[1、今日 2、昨天 3、7日 4、30日 0 、最大和自定义]
export const getAgentUserReport = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentUserReport(payload);
};
// 代理 财务页面 - 提成记录 start_time end_time play_ids 游戏ID，可传多个，逗号分割  需要传big_type
// big_type 分类 2棋牌， 3电子， 4捕鱼，5真人，6体育，7彩票，8红包
export const getAgentTichengReport = (payload = {}) => {
  const userStore = useUserStore();
  return userStore.reqAgentTichengReport(payload);
};
